module.exports = __webpack_public_path__ + "static/img/head_portrait.5b5bfa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head_portrait.jpg
// module id = XibN
// module chunks = 42